/**
 * Create a new object with default properties
 * @param a 
 * @param b 
 * 
 * @example
 * // { foo: 'bar', oh: 'yeah' }
 * defaults({ foo: 'bar' }, {
 *   foo: 'baz',
 *   oh: 'yeah',
 * })
 */
export function defaults<A, B>(a: Partial<A>, b: Partial<B>): A & B {
  const result: any = {}

  for (let k in a) {
    result[k] = a[k]
  }

  for (let k in b) {
    if (result[k] === undefined) result[k] = b[k]
  }

  return result
}



// WEBPACK FOOTER //
// ./node_modules/@cloudflare/defaults/src/index.ts